import { comparisonPlatforms } from "@/mocks/categories";

export default function ComparisonSection() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <p className="text-xs font-medium text-foreground-500 uppercase tracking-widest mb-3">
            Trusted Comparison Data
          </p>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-tight mb-4">
            Compare{" "}
            <span className="italic">Spreadsheet</span> Platforms
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            See how Hipobuy Spreadsheet stacks up against other popular product
            discovery platforms used by millions of shoppers worldwide.
          </p>
        </div>

        <div className="flex flex-col lg:flex-row gap-5">
          <div className="flex-1 bg-accent-500 rounded-2xl p-6 md:p-8 relative overflow-hidden group">
            <div className="absolute top-4 right-4 w-10 h-10 flex items-center justify-center rounded-full bg-background-50/30 text-background-50">
              <i className="ri-arrow-right-up-line text-lg"></i>
            </div>
            <span className="font-heading text-6xl md:text-7xl font-bold text-background-50 block mb-3">
              98%
            </span>
            <p className="text-base md:text-lg text-background-50/90 font-medium mb-1">
              User Satisfaction Rate
            </p>
            <p className="text-sm text-background-50/70 italic">
              Based on verified community feedback
            </p>
          </div>

          <div className="flex-1 bg-secondary-500 rounded-2xl p-6 md:p-8 relative overflow-hidden group">
            <div className="absolute top-4 right-4 w-10 h-10 flex items-center justify-center rounded-full bg-background-50/30 text-background-50">
              <i className="ri-arrow-right-up-line text-lg"></i>
            </div>
            <span className="font-heading text-6xl md:text-7xl font-bold text-foreground-950 block mb-3">
              50K+
            </span>
            <p className="text-base md:text-lg text-foreground-800 font-medium mb-1">
              Products in Database
            </p>
            <p className="text-sm text-foreground-700/80 italic">
              Continuously updated product catalog
            </p>
          </div>
        </div>

        <div className="mt-10 overflow-x-auto">
          <table className="w-full min-w-[600px] text-left border-collapse">
            <thead>
              <tr className="border-b border-background-300/60">
                <th className="py-3 px-4 text-xs font-medium text-foreground-500 uppercase tracking-wider">
                  Platform
                </th>
                <th className="py-3 px-4 text-xs font-medium text-foreground-500 uppercase tracking-wider">
                  Best For
                </th>
                <th className="py-3 px-4 text-xs font-medium text-foreground-500 uppercase tracking-wider">
                  Rating
                </th>
              </tr>
            </thead>
            <tbody>
              {comparisonPlatforms.map((platform) => (
                <tr
                  key={platform.name}
                  className={`border-b border-background-200/70 ${
                    platform.highlight ? "bg-primary-50/50" : ""
                  }`}
                >
                  <td className="py-3 px-4 text-sm font-medium text-foreground-900 whitespace-nowrap">
                    {platform.highlight && (
                      <span className="inline-block w-2 h-2 rounded-full bg-primary-500 mr-2"></span>
                    )}
                    {platform.name}
                  </td>
                  <td className="py-3 px-4 text-sm text-foreground-600">
                    {platform.bestFor}
                  </td>
                  <td className="py-3 px-4 text-sm text-accent-500 whitespace-nowrap">
                    {platform.rating}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}